import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createInvoicesSchemas } from 'shared/db/validation/schema/invoices';
import { Validator } from 'shared/db/validation/validator';
import { InvoiceRawRecord, InvoiceUpdateRawRecord } from 'shared/types/Invoice';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { InvoicesDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createInvoicesSchemas();

const addValidator = createDBEntityValidator<InvoiceRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<InvoiceUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-invoices'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createInvoicesInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const invoicesInputValidation: InvoicesDBValidation = {
    add: createInvoicesInputValidation(addValidator, validationStrategy),
    update: createInvoicesInputValidation(updateValidator, validationStrategy),
    delete: createInvoicesInputValidation(deleteValidator, validationStrategy),
};
